import React, { useState, useRef, useEffect } from "react";
import AdrTentativeAgreementContractorSignModalV3 from "./AdrTentativeAgreementContractorSignModalV3";
import AdrTentativeAgreementSignModalV3 from "./AdrTentativeAgreementSignModalV3";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdrTentativeAgreementDisputeModalV3 from "./AdrTentativeAgreementDisputeModalV3";
import AlertModal from "../_common/AlertModal";

function AdrTentativeAgreementSignaturesV3(props) {
  const { adrIsReadOnly, getPdf, projectId, email, isLocked, ...rest } = props;

  const [modalState_dispute, setModalState_dispute] = useState({
    showModal: false,
    data: null,
  });
  const toggleModal_dispute = () =>
    setModalState_dispute({
      ...modalState_dispute,
      showModal: !modalState_dispute.showModal,
    });

  const [showCaltransSignModal, _toggleCaltransSignModal] = useState(false);
  const toggleCaltransSignModal = () => _toggleCaltransSignModal(!showCaltransSignModal);

  const [showContractorSignModal, _toggleContractorSignModal] = useState(false);
  const toggleContractorSignModal = () =>
    _toggleContractorSignModal(!showContractorSignModal);

  const onCaltransDispute = () => {
    setModalState_dispute({
      showModal: true,
      data: {
        name: rest.caltransRepName,
        remarks: rest.caltransRepRemarks,
        disputedBy: "ct",
        applyDispute: (fieldsForDispute) => {
          rest.applyCaltransSignature({
            caltransRepSignature: "",
            isWetSignedByCaltransRep: false,
            caltransRepSignedOn: null,
            caltransRepName: fieldsForDispute.name,
            caltransRepRemarks: fieldsForDispute.remarks,
            isDisputedByCaltransRep: true,
          });
        },
      },
    });
  };

  const onCaltransUndoDispute = () => {
    rest.applyCaltransSignature({
      caltransRepSignature: "",
      isWetSignedByCaltransRep: false,
      caltransRepSignedOn: null,
      caltransRepName: rest.caltransRepName,
      caltransRepRemarks: rest.caltransRepRemarks,
      isDisputedByCaltransRep: false,
    });
  };

  const onContractorDispute = () => {
    if (!Object.keys(rest.contractorsClient).length) return;
    const ccs = _.cloneDeep(rest.contractorsClient);
    const cc = ccs[Object.keys(ccs)[0]];
    setModalState_dispute({
      showModal: true,
      data: {
        name: cc.contractorRepName,
        remarks: cc.contractorRepRemarks,
        disputedBy: "contractor",
        applyDispute: (fieldsForDispute) => {
          (cc.contractorRepSignature = ""), (cc.isWetSignedByContractor = false);
          cc.contractorRepSignedOn = null;
          cc.contractorRepName = fieldsForDispute.name;
          cc.contractorRepRemarks = fieldsForDispute.remarks;
          cc.isDisputedByContractor = true;
          rest.applyContractorSignatures(ccs);
        },
      },
    });
  };

  const onContractorUndoDispute = () => {
    const ccs = _.cloneDeep(rest.contractorsClient);
    if (!Object.keys(ccs).length) return;
    ccs[Object.keys(ccs)[0]].contractorRepSignature = "";
    ccs[Object.keys(ccs)[0]].isWetSignedByContractor = false;
    ccs[Object.keys(ccs)[0]].contractorRepSignedOn = null;
    ccs[Object.keys(ccs)[0]].isDisputedByContractor = false;
    rest.applyContractorSignatures(ccs);
  };

  return (
    <>
      <div className="card my-2">
        <div className="card-body m-2 p-0">
          <div className="d-flex flex-row mt-0">
            <div className="w-50 mr-1">
              <AdrTentativeAgreementSignaturesPanelV3
                signatureFor="Caltrans Rep"
                isLocked={isLocked}
                adrIsReadOnly={adrIsReadOnly}
                toggleSignModal={toggleCaltransSignModal}
                isSigned={!rest.isDisputedByCaltransRep && rest.caltransRepSignedOn}
                isDisputed={rest.isDisputedByCaltransRep}
                onDispute={onCaltransDispute}
                onUndoDispute={onCaltransUndoDispute}
                email={email}
              />
            </div>
            <div className="w-50">
              <AdrTentativeAgreementSignaturesPanelV3
                signatureFor="Contractor"
                isLocked={isLocked}
                adrIsReadOnly={adrIsReadOnly}
                toggleSignModal={toggleContractorSignModal}
                isSigned={Object.values(rest.contractorsClient)
                  .filter((cc) => !cc.isDisputedByContractor)
                  .some((cc) => cc.contractorRepSignedOn)}
                isDisputed={Object.values(rest.contractorsClient).some(
                  (cc) => cc.isDisputedByContractor
                )}
                onDispute={onContractorDispute}
                onUndoDispute={onContractorUndoDispute}
                email={email}
              />
            </div>
          </div>
        </div>
      </div>
      {showCaltransSignModal && (
        <AdrTentativeAgreementSignModalV3
          showModal={showCaltransSignModal}
          toggleModal={toggleCaltransSignModal}
          isLocked={isLocked}
          forCustomTa={rest.formType === "custom"}
          applySignature={rest.applyCaltransSignature}
          caltransRepSignature={rest.caltransRepSignature}
          isWetSignedByCaltransRep={rest.isWetSignedByCaltransRep}
          caltransRepSignedOn={rest.caltransRepSignedOn}
          caltransRepName={rest.caltransRepName}
          caltransRepRemarks={rest.caltransRepRemarks}
          isDisputedByCaltransRep={rest.isDisputedByCaltransRep}
        />
      )}
      {showContractorSignModal && (
        <AdrTentativeAgreementContractorSignModalV3
          projectId={projectId}
          showModal={showContractorSignModal}
          toggleModal={toggleContractorSignModal}
          isLocked={isLocked}
          forCustomTa={rest.formType === "custom"}
          contractorsClient={rest.contractorsClient}
          applySignatures={rest.applyContractorSignatures}
        />
      )}
      {modalState_dispute.showModal && (
        <AdrTentativeAgreementDisputeModalV3
          showModal={modalState_dispute.showModal}
          toggleModal={toggleModal_dispute}
          data={modalState_dispute.data}
        />
      )}
    </>
  );
}

function AdrTentativeAgreementSignaturesPanelV3(props) {
  const {
    signatureFor,
    toggleSignModal,
    isLocked,
    adrIsReadOnly,
    isSigned,
    isDisputed,
    onDispute,
    onUndoDispute,
    email,
  } = props;

  const [showAlert_disputeConfirm, _setShowAlert_disputeConfirm] = useState(false);
  const toggleAlert_disputeConfirm = () =>
    _setShowAlert_disputeConfirm(!showAlert_disputeConfirm);

  const handleClick_sign = (e) => {
    e.preventDefault();
    toggleSignModal();
  };

  const handleClick_dispute = (e) => {
    e.preventDefault();
    if (isDisputed) onUndoDispute();
    else toggleAlert_disputeConfirm();
  };

  const handleClick_email = (e) => {
    e.preventDefault();
    email();
  };

  const handleAlert_disputeConfirm = (actionType) => (e) => {
    e.preventDefault();
    if (actionType === "accept") {
      onDispute();
    }
    toggleAlert_disputeConfirm();
  };

  const renderSignStatus = () => {
    // Only check for signedOn (instead of signature), since it is common to both
    // form types
    return isSigned ? (
      <span className="font-weight-bold" style={{ color: "green" }}>
        Signed
      </span>
    ) : isDisputed ? (
      <span
        className="font-weight-bold"
        style={{ color: "black", backgroundColor: "yellow" }}
      >
        Disputed
      </span>
    ) : (
      <span className="font-weight-bold" style={{ color: "red" }}>
        Pending
      </span>
    );
  };

  return (
    <React.Fragment>
      <div className="card w-100">
        <div className="card-header py-1 px-2">
          Signature For: <b>{signatureFor}</b>
        </div>
        <div className="card-body px-2 py-1">
          <div className="form-row">
            <div className="col">
              <span className="font-weight-bold align-middle mr-1">Status:</span>
              <span className="align-middle mr-2">{renderSignStatus()}</span>
            </div>
          </div>
          {!adrIsReadOnly && (
            <div className="form-row form-group mt-2 mb-1">
              <div className="col">
                <button
                  id="signTa"
                  name="signTa"
                  className="btn btn-sm btn-success mr-2"
                  onClick={handleClick_sign}
                >
                  <b>Sign</b>
                </button>
                <button
                  id="disputeTa"
                  name="disputeTa"
                  className="btn btn-sm btn-warning mr-2"
                  onClick={handleClick_dispute}
                >
                  {isDisputed ? "Undo Dispute" : "Dispute"}
                </button>
                <button
                  id="emailTa"
                  name="emailTa"
                  className="btn btn-sm btn-secondary mr-2"
                  onClick={handleClick_email}
                >
                  <FontAwesomeIcon icon="envelope" className="fa-fw mr-1" />
                  Email for Review
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      {showAlert_disputeConfirm && (
        <AlertModal
          alertKey="taDisputeConfirm"
          alertTitle="Confirm Dispute"
          alertTitleClass="bg-warning"
          alertTitleIcon="exclamation-triangle"
          alertText="Dispute this TA?"
          acceptCaption={"Yes"}
          acceptClass={"danger"}
          provideReject={true}
          rejectCaption={"No"}
          rejectClass={"secondary"}
          handleAlertAction={handleAlert_disputeConfirm}
          showAlertModal={showAlert_disputeConfirm}
          toggleAlertModal={toggleAlert_disputeConfirm}
        />
      )}
    </React.Fragment>
  );
}

export default AdrTentativeAgreementSignaturesV3;
